import Parse from "parse";
import ParseConfig from "../api/parse.config";
const authService = {
  async logIn(email, password) {
    try {
      ParseConfig();
      console.log("email", email);
      const userQuery = new Parse.Query("User");
      userQuery.equalTo("username", email);
      const responseUser = await userQuery.first();
      console.log("responseUser", responseUser);
      const adminRoleQuery = new Parse.Query(Parse.Role);
      adminRoleQuery.equalTo("name", "Group Managers");
      const adminRoleResponse = await adminRoleQuery.first();
      const adminRoleRelation = adminRoleResponse.relation("users");
      const userInAdminRoleQuery = adminRoleRelation.query();
      userInAdminRoleQuery.equalTo("username", email);
      const responseUserInAdminRole = await userInAdminRoleQuery.first();

      if (responseUser && responseUserInAdminRole) {
        await Parse.User.logIn(email, password);
        return { success: true, user: Parse.User.current() };
      } else {
        return {
          success: false,
          error: "User not found or conditions not met",
        };
      }
    } catch (error) {
      console.error("Error while logging in:", error);
      return { success: false, error: error.message };
    }
  },
  isAuthenticated() {
    // Check if there is a current Parse User
    const currentUser = Parse.User.current();
    return currentUser !== null;
  },
};

export default authService;
